export const contact = {
    title: 'ติดต่อเรา',
    content_title: 'เบอร์เกอร์คิง ไทยแลนด์',
    callcenter_title: 'คอลเซ็นเตอร์',
    social_title: 'Social media',
    social_burgerKingTh: 'BurgerKingThailand',
    operateHrs9_24: 'ทุกวัน (07.00-02.00)',
    operateHrs24_9: 'ทุกวัน (24.00-09.00)',
    call: 'โทร',
    tel1: '1112',
    tel2: '02-0349240',
}
